import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { loadDrinkCollectionSummary } from '../../api/drinkCollectionApi';
import { DRINK_DISCOVERY_EVENT } from '../../utils/drinkDiscovery';

export default function CollectionSummaryCard() {
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    const load = () => loadDrinkCollectionSummary()
      .then(data => { if (active) { setSummary(data); setError(''); } })
      .catch(() => { if (active) setError('Logbuch gerade nicht verfügbar.'); });
    load();
    window.addEventListener(DRINK_DISCOVERY_EVENT, load);
    return () => { active = false; window.removeEventListener(DRINK_DISCOVERY_EVENT, load); };
  }, []);

  return (
    <section className="pfp-collection-summary-card" aria-labelledby="pfp-collection-summary-title">
      <div>
        <span className="pfp-collection-eyebrow">Persönliche Sammlung</span>
        <h3 id="pfp-collection-summary-title">Dein Getränke-Logbuch</h3>
        {summary ? (
          <p><strong>{summary.discovered} von {summary.total}</strong> entdeckt · {summary.percent}% · {summary.discovered_this_month} in diesem Monat</p>
        ) : <p>{error || 'Logbuch wird geladen …'}</p>}
      </div>
      <Link to="/collection" className="pfp-collection-primary-button">Logbuch öffnen</Link>
    </section>
  );
}
